import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
import { toast } from "react-toastify";
import axiosInstance from "../../../Components/api/axiosInstance";

export const uploadimage = createAsyncThunk("imageupload", async (data) => {
  try {
    const response = await axiosInstance.post(
      `${process.env.REACT_APP_API_URL}/vessels/upload-project-image`,
      data,
    );
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.message);
  }
});

const uploadImageSlice = createSlice({
  name: "uploadimage",
  initialState: {
    uploadimage: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadimage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadimage.fulfilled, (state, action) => {
        state.loading = false;
        state.addproject = action.payload;
      })
      .addCase(uploadimage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default uploadImageSlice.reducer;
